import * as React from "react";
import PropTypes from 'prop-types';

const SvgShieldNew = props => {
  if (props.id !== "_svgshieldnew") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 24 24" {...props}><path fill="#202020" fillRule="evenodd" d="M19.5 3v10.717s-.443 5.007-7.23 7.198L12 21l-.27-.085c-6.787-2.19-7.23-7.198-7.23-7.198V3h15zm-4.671 4.29l-3.657 4.859-1.504-1.104a1.277 1.277 0 00-1.764.246 1.215 1.215 0 00.252 1.727l2.52 1.852a1.28 1.28 0 001.772-.255l4.411-5.862a1.218 1.218 0 00-.267-1.726 1.278 1.278 0 00-1.763.262z" /></svg>;
};

SvgShieldNew.displayName = "_svgshieldnew";
SvgShieldNew.propTypes = {
  id: PropTypes.string
};
SvgShieldNew.defaultProps = {
  id: ''
};
export default SvgShieldNew;